import { z } from "zod";
//#region src/cp-dcr-redirect-hosts.ts
/**
* The answers of the control plane DCR redirect host registry of cp-auth-api,
* `/v1/auth/oauth2/dcr-redirect-hosts` (`DcrRedirectHostsController`; plan 2026-10-21-operator-tui,
* R-054e, F1).
*
* The request bodies are the shared `createDcrRedirectHostSchema` and
* `updateDcrRedirectHostSchema` of `./oauth.js`: the cp-auth-api DTOs match them field for field.
* The DP summary `dcrRedirectHostSummarySchema` does not fit the CP answer. The CP row names
* `createdByOperatorId`, and the DP row names `createdByUserId`.
*
* A delete answers `cpMessageResponseSchema` of `./dp-recovery.js`.
*/
/**
* One CP registry row, the answer of get, create and update. `host` is lower case and immutable.
* `enabled: false` stops new registrations on the host only; clients already registered under it
* keep their access. `createdByOperatorId` is `null` when no operator is on record.
*/
const cpDcrRedirectHostSchema = z.object({
	id: z.uuid(),
	host: z.string().min(1),
	description: z.string().nullable(),
	enabled: z.boolean(),
	createdByOperatorId: z.uuid().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
}).strict();
/** The answer of the list route: every row, enabled or not. `[]` means the registry is empty. */
const cpDcrRedirectHostListSchema = z.array(cpDcrRedirectHostSchema);
//#endregion
export { cpDcrRedirectHostListSchema, cpDcrRedirectHostSchema };

//# sourceMappingURL=cp-dcr-redirect-hosts.js.map